// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaGallery__wrapper-ed5f58 {
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--addition-40);
  --gallery-view-padding: 24px;
}

.MediaGallery__content-c0e6cd {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
}

.MediaGallery__loader-b232f6 {
  flex: 1;
  display: flex;
  justify-content: center;
  margin-top: auto;
  margin-bottom: auto;
}`, "",{"version":3,"sources":["webpack://./src/main/components/MediaGallery/MediaGallery.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EAEA,4BAAA;AAAF;;AAGA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AAAF;;AAGA;EACE,OAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAAF","sourcesContent":[".wrapper {\n  position: fixed;\n  display: flex;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--addition-40);\n\n  --gallery-view-padding: 24px;\n}\n\n.content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  height: 100%;\n}\n\n.loader {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  margin-top: auto;\n  margin-bottom: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `MediaGallery__wrapper-ed5f58`,
	"content": `MediaGallery__content-c0e6cd`,
	"loader": `MediaGallery__loader-b232f6`
};
module.exports = ___CSS_LOADER_EXPORT___;
